import { Box, Button, FileInput, Group, Image, LoadingOverlay, Select, SimpleGrid, Space, Textarea, TextInput } from '@mantine/core'
import React, { memo, useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { notifications } from '@mantine/notifications';
import ProductAddMoreDetail from './ProductAddMoreDetail.component'
import useFetch from '../../../../../Customhooks/useFetch';
import { baseUrl } from '../../../../../Constants/constant';
import classes from './ProductSelection.module.css';
import { authContext } from '../../../../../context/AuthProvider.component';

interface TransportField {
    id_comp_trans: number;
    id: number | null;
    sourcelocation_id: string;
    source_place_id: string;
    transportType_id: string | null;
    destinationlocation_name: string;
    destination_place_id: string;
    distance: any;
}
interface FormField {
    id_comp: number;
    id: number | null;
    factory_name: string | null;
    vertical_id: string | null;
    material_name: string | null;
    materialSub_type_name: string | null;
    process: string;
    weight: string;
    percentage: string;
    weight_type: string;
    gsm_size: string;
    sheet_size_height: string;
    sheet_size_width: string;
    no_of_product: string;
    // no_of_layers: string;
    // glue_Co2: string;
    // coverage: string;
    // ink_co2: string;
    transportData?: TransportField[];
}

interface ProductForm {
    // username: string,
    report_name: string,
    product_name: string,
    product_image: File | null,
    product_description: string,
    product_image_existing: string,
    // product_version_id: number,
    database_version_id: string | null,
    compute_components: Array<{
        id: number | null;
        factory_name: string | null;
        vertical_id: string | null;

        raw_material_id: string | null;
        raw_material_sub_id: string | null;
        weight: string;
        percentage: string;
        gsm_size: string;
        sheet_size: string;
        no_of_product: string;
        // no_of_layers: string;
        // glue_Co2: string;
        // coverage: string;
        // ink_co2: string;
    }>;
}
const jsonToFormData = (obj: any) => {
    const formData = new FormData();

    Object.keys(obj).forEach(key => {
        if (obj[key] instanceof File) {
            formData.append(key, obj[key]);
        } else if (Array.isArray(obj[key]) || typeof obj[key] === 'object') {
            formData.append(key, JSON.stringify(obj[key]));
        } else {
            formData.append(key, obj[key]);
        }
    });

    return formData;
};

const ProductDetails = ({ isProduct, id_p, id_c, gsm, onClose }: any) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const token = localStorage.getItem("token") || "";
    const updatedUrl = baseUrl.replace("/api/", "");

    const [productName, setProductName] = useState<string>('');
    const [fileItem, setFileItem] = useState<File | null>(null);
    const [weightType, setWeightType] = useState<any>()
    const [reportName, setReportName] = useState<string>('');
    const [dbversion, setDbversion] = useState<any>();
    const [selectedDBversion, setSelectedDBversion] = useState<any>();
    const [productDescription, setProductDescription] = useState('');
    const [formData, setFormData] = useState<FormField[]>([]);
    const [isValid, setIsValid] = useState(false);
    const [errors, setErrors] = useState<Record<string, string>>({});
    const [requestData, setRequestData] = useState<ProductForm | null>(null);
    const [showErrors, setShowErrors] = useState(false);
    const [preview, setPreview] = useState<string | null>(null);
    const [imageUrl, setImageUrl] = useState<string>('');
    const [imageExisting, setimageExisting] = useState<string>('');
    const [initialProductCharacteristics, setInitialProductCharacteristics] = useState<FormField[]>([]);
    const { auth, setComputeId, computeId, draftLca, setDraftLca } = useContext<any>(authContext);

    // Fetch product data hook
    const {
        data: getDataproductid,
        loading: ProductIdLoading,
        error,
        fetchData: fetchProductDetails
    } = useFetch({
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            "token": token,
        },
    });
    const {
        data: getDataComputeid,
        loading: computeIdLoading,
        error: getErrorCompute,
        fetchData: fetchComputeProductDetails
    } = useFetch({
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            "token": token,
        },
    });
    const {
        data: dataVersion,
        error: errorVersion,
        fetchData: fetchDBversion,
    } = useFetch({
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            "token": token,
        },
    });

    // Save/Update product hook
    const {
        data: productData,
        error: productError,
        loading: productLoading,
        fetchData: postProductLca
    } = useFetch({
        method: computeId ? 'PUT' : 'POST',
        headers: {
            "Access-Control-Allow-Origin": "*",
            token: token,
        },
        body: requestData ? requestData : undefined
    });

    // Fetch product data if editing
    useEffect(() => {
        if (id) {
            fetchProductDetails(`${baseUrl}admin/products/${id}`);
        }
        if (isProduct === 'yes' && id_p) {
            fetchProductDetails(`${baseUrl}admin/products/${id_p}`);
        }
    }, [id, id_p, isProduct]);
    useEffect(() => {
        if (!id_c) return;
        if (id_c) {
            fetchComputeProductDetails(`${baseUrl}compute/lca/${id_c}?is_draft=${draftLca}`);
        }
    }, [id_c, draftLca]);
    useEffect(() => {
        fetchDBversion(`${baseUrl}admin/database-version`);
    }, []);
    useEffect(() => {
        if (!getDataproductid) return;
        if (getDataproductid?.data) {
            setProductName(getDataproductid?.data?.rows[0]?.name);
            setProductDescription(getDataproductid?.data?.rows[0]?.product_description);
            setWeightType(getDataproductid?.data?.rows[0]?.ProductComponents[0]?.RawMaterialSubType?.Weighttype?.weight_name);
            setImageUrl(getDataproductid?.data?.rows[0]?.product_image)
            setimageExisting(getDataproductid?.data?.rows[0]?.product_image)

            if (getDataproductid.data?.rows[0]?.ProductComponents) {
                const transformedFields = getDataproductid?.data?.rows[0]?.ProductComponents?.map((char: any, index: number) => ({
                    id_comp: index + 1,
                    // country: char.country_id,
                    // ...(char.id ? { id: char.id } : {}),
                    vertical_id: char?.vertical_id,
                    // category_id: char.category_id,
                    material_name: char?.raw_material_id,
                    materialSub_type_name: char?.raw_material_sub_id,
                    process: char?.RawMaterialSubType?.Process?.process_name,
                    weight_type: char?.RawMaterialSubType?.Weighttype?.weight_name,
                    // water_consumption: char?.water_consumtion,
                    weight: char?.weight,
                    percentage: char?.percentage,
                    gsm_size: char?.gsm_size,
                    sheet_size_height: char?.sheet_size_height,
                    sheet_size_width: char?.sheet_size_width,
                    no_of_product: char?.no_of_product,
                    // no_of_layers: char?.no_of_layer,
                    // glue_Co2: char?.glue_type_co2,
                    // coverage: char?.coverage,
                    // ink_co2: char?.ink_type_co2,
                }));

                setInitialProductCharacteristics(transformedFields);
                setFormData(transformedFields);
            }
        }
    }, [getDataproductid]);
    useEffect(() => {
        if (!getDataComputeid) return;
        if (getDataComputeid?.data) {
            setReportName(getDataComputeid?.data?.rows[0]?.report_name);
            setProductName(getDataComputeid?.data?.rows[0]?.product_name);
            setProductDescription(getDataComputeid?.data?.rows[0]?.product_description);
            setImageUrl(getDataComputeid?.data?.rows[0]?.product_image)
            setimageExisting(getDataComputeid?.data?.rows[0]?.product_image)

            // Ensure `dbversion` exists before setting `selectedDBversion`
            if (dbversion?.length > 0) {
                setSelectedDBversion((prev: any) =>
                    prev ?? dbversion?.find((v: any) => v.label === getDataComputeid?.data?.rows[0]?.DatabaseVersion?.db_version)?.value ?? null
                );
            }

            if (getDataComputeid.data?.rows[0]?.ComputeComponents) {
                const transformedFields = getDataComputeid?.data?.rows[0]?.ComputeComponents.map((char: any, index: number) => ({
                    id_comp: index + 1,
                    ...(char?.id ? { id: char?.id } : {}),
                    factory_name: char?.location_id,
                    vertical_id: char?.vertical_id,
                    material_name: char?.raw_material_id,
                    materialSub_type_name: char?.raw_material_sub_id,
                    process: char?.RawMaterialSubType?.Process?.process_name,
                    weight_type: char?.RawMaterialSubType?.Weighttype?.weight_name,
                    weight: char?.weight,
                    percentage: char?.percentage,
                    gsm_size: char?.gsm_size,
                    sheet_size_width: char?.sheet_size_width,
                    sheet_size_height: char?.sheet_size_height,
                    no_of_product: char?.no_of_product,
                    // no_of_layers: char?.no_of_layer,
                    // glue_Co2: char?.glue_type_co2,
                    // coverage: char?.coverage,
                    // ink_co2: char?.ink_type_co2,
                    transportData: (char?.ComputeLocationComponents || [])?.map((transport: any, transIndex: number) => ({
                        id_comp_trans: transIndex + 1,
                        id: transport?.id || null,
                        sourcelocation_id: transport?.source_location_id || "",
                        source_place_id: transport.source_place_id || '',
                        transportType_id: transport?.transportation_id || null,
                        destinationlocation_name: transport?.destination_location_id || "",
                        destination_place_id: transport.destination_place_id || ''
                    })),
                }));

                setTimeout(() => {
                }, 500);
                setInitialProductCharacteristics(transformedFields);
                setFormData(transformedFields);
            }
        }
    }, [getDataComputeid, dbversion]);


    const showNotification = (type: 'success' | 'error', message: string) => {
        notifications.show({
            title: type === 'success' ? 'Success' : 'Error',
            message,
            color: type === 'success' ? 'green' : 'red',
            classNames: classes,
        });
    };

    const handleFieldsChange = (fields: FormField[]) => {
        setFormData(fields);
    };

    const handleValidationChange = (valid: boolean) => {
        setIsValid(valid);
    };

    const validateForm = (): boolean => {
        const newErrors: Record<string, string> = {};

        if (!productName.trim()) {
            newErrors.product_name = 'Product name is required';
        }
        if (!productDescription.trim()) {
            newErrors.product_description = 'Product Description is required';
        }
        if (!reportName.trim()) {
            newErrors.report_name = 'Report Name is required';
        }
        if (!selectedDBversion || !selectedDBversion.trim()) {
            newErrors.database_version_id = 'Database Version is required';
        }
        // if (!id_p && !id_c) {
        //     if (!fileItem) {
        //         newErrors.product_icon = 'Product Image is required';
        //     } else if (!(fileItem instanceof File)) {
        //         newErrors.product_icon = 'Invalid file format';
        //     }
        // }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0 && isValid;
    };

    const handleSave = async (e: any) => {
        e.preventDefault();
        setShowErrors(true);  // Show errors when save is clicked
        setDraftLca(0)

        if (!validateForm()) {
            showNotification('error', 'Please fill all required fields');
            return;
        }
        if (!isValid) {
            showNotification('error', 'Please fill all required fields');
            return;
        }
        // const userName = localStorage.getItem("username")

        const data: ProductForm = {
            // username: userName || "",
            report_name: reportName,
            product_name: productName,
            product_description: productDescription,
            database_version_id: selectedDBversion,
            product_image: fileItem,
            product_image_existing: imageExisting,
            // product_version_id: 1,
            compute_components: formData?.map(field => {
                const componentData: any = {
                    location_id: field?.factory_name,
                    vertical_id: field?.vertical_id,
                    raw_material_id: field?.material_name,
                    raw_material_sub_id: field?.materialSub_type_name,
                    compute_location_components: field?.transportData?.map(transport => ({
                        source_location_id: transport?.sourcelocation_id,
                        source_place_id: transport.source_place_id,
                        transportation_id: transport?.transportType_id,
                        destination_location_id: transport?.destinationlocation_name,
                        destination_place_id: transport.destination_place_id,

                    }))
                };

                if (field?.id) {
                    componentData.id = field?.id;
                }
                if (field?.weight) {
                    componentData.weight = field?.weight;
                }
                if (field?.percentage) {
                    componentData.percentage = field?.percentage;
                }
                if (field?.gsm_size) {
                    componentData.gsm_size = field?.gsm_size;
                }
                if (field?.sheet_size_height) {
                    componentData.sheet_size_height = field?.sheet_size_height;
                }
                if (field?.sheet_size_width) {
                    componentData.sheet_size_width = field?.sheet_size_width;
                }
                if (field?.no_of_product) {
                    componentData.no_of_product = field?.no_of_product;
                }
                // if (field?.no_of_layers) {
                //     componentData.no_of_layer = field?.no_of_layers;
                // }
                // if (field?.glue_Co2) {
                //     componentData.glue_type_co2 = field?.glue_Co2;
                // }
                // if (field?.coverage) {
                //     componentData.coverage = field?.coverage;
                // }
                // if (field?.ink_co2) {
                //     componentData.ink_type_co2 = field?.ink_co2;
                // }

                return componentData;
            })
        };
        const ProductData: any = jsonToFormData(data);
        setRequestData(ProductData);
    };

    useEffect(() => {
        const makeApiCall = async () => {
            if (requestData) {
                const url = computeId ? `${baseUrl}compute/lca/edit/${computeId}` : `${baseUrl}compute/lca/addLca`;
                await postProductLca(url);
            }
        };

        makeApiCall();
    }, [requestData]);
    useEffect(() => {
        if (fileItem) {
            const objectUrl = URL.createObjectURL(fileItem);
            setPreview(objectUrl);
            return () => URL.revokeObjectURL(objectUrl); // Cleanup
        }
    }, [fileItem]);

    useEffect(() => {
        if (dataVersion?.data?.rows) {
            setDbversion(
                dataVersion?.data?.rows?.map((el: any) => ({
                    value: el?.id.toString(),
                    label: el?.db_version,
                }))
            );
        }
    }, [dataVersion])

    useEffect(() => {
        if (productData && productData.data?.compute_id) {
            setComputeId(productData?.data?.compute_id); // Store computeId globally
        }
    }, [productData]);

    useEffect(() => {
        if (productError || (productData && productData.errors)) {
            showNotification('error', productData?.message || productError?.message || 'Something went wrong');
            return;
        }

        if (productData && !productData.errors) {
            showNotification('success', 'Product saved successfully');
            onClose()
        }
    }, [productData, productError]);
    return (
        <>
            {(ProductIdLoading || computeIdLoading) && (
                <LoadingOverlay
                    visible={true}
                    zIndex={1000}
                    overlayProps={{
                        radius: 'sm',
                        blur: 2,
                        style: {
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%'
                        }
                    }}
                    loaderProps={{ color: '#404040', type: 'bars' }}
                />
            )}
            {id_p && <Space h={'lg'} />}
            <>
                <Box>
                    <SimpleGrid cols={3}>
                        <TextInput
                            label="Report Name"
                            placeholder="Enter Report name"
                            value={reportName}
                            onChange={(e) => setReportName(e.target.value)}
                            variant="filled"
                            withAsterisk
                            radius={6}
                            error={errors.report_name}
                        />
                        <TextInput
                            label="Product Name"
                            placeholder="Enter product name"
                            value={productName}
                            onChange={(e) => setProductName(e.target.value)}
                            variant="filled"
                            withAsterisk
                            radius={6}
                            error={errors.product_name}
                        />
                        {/* {(id_p || id_c) && <TextInput
                            label="Product Id"
                            placeholder="Enter product Id"
                            value={id_p ? id_p : id_c}
                            variant="filled"
                            withAsterisk
                            radius={6}
                            disabled
                        />} */}
                        <Select
                            label="Database Version"
                            withAsterisk
                            variant='filled'
                            placeholder='Select Version'
                            data={dbversion}
                            searchable
                            maxDropdownHeight={200}
                            comboboxProps={{ withinPortal: false, shadow: 'md' }}
                            value={selectedDBversion}
                            onChange={(value) => setSelectedDBversion(value)}
                            radius={6}
                            error={errors.database_version_id}
                        />
                        <FileInput
                            label="Upload icon"
                            // withAsterisk={id ? false : true}
                            variant="filled"
                            placeholder="Upload icon"
                            value={fileItem}
                            onChange={setFileItem}
                            radius={6}
                            // error={errors.product_icon}
                        />
                        {preview ? (
                            <Box className={classes.verticalslogo}>
                                <Image fit="contain" src={preview} alt="icon" />
                            </Box>
                        ) : (id_c || id_p) && updatedUrl && imageUrl ? (
                            <Box className={classes.verticalslogo}>
                                <Image fit="contain" src={`${updatedUrl}${imageUrl}`} alt="icon" />
                            </Box>
                        ) : null}
                    </SimpleGrid>
                    <Space h={'md'} />
                    <Textarea
                        label="Product Description"
                        placeholder="Enter your Product Description"
                        withAsterisk
                        variant="filled"
                        autosize
                        value={productDescription}
                        onChange={(e) => setProductDescription(e.target.value)}
                        minRows={2}
                        maxRows={4}
                        radius={6}
                        error={errors.product_description}
                    />
                    <Space h={'xl'} />
                    <ProductAddMoreDetail
                        onFieldsChange={handleFieldsChange}
                        onValidationChange={handleValidationChange}
                        showErrors={showErrors}
                        initialFields={initialProductCharacteristics}
                        gsm={weightType}
                        computeId={computeId}
                        id_p={id_p}
                    />
                </Box>

                <Box className={classes.Productbutton}>
                    <Group grow>
                        <Button
                            variant="default"
                            radius={6}
                            w={190}
                            onClick={() => { onClose() }}
                        >
                            Close
                        </Button>
                        <Button
                            variant="gradient"
                            radius={6}
                            size='sm'
                            gradient={{ from: '#404040', to: '#404040', deg: 90 }}
                            onClick={handleSave}
                            loading={productLoading}
                        >
                            Next
                        </Button>
                    </Group>
                </Box>
            </>
        </>
    )
}

export default memo(ProductDetails)